import React, { useState } from 'react';
import API from '../api/api';

function ForgotPassword({ onBack }) {
  const [step, setStep] = useState(1);
  const [username, setUsername] = useState('');
  const [hiddenEmail, setHiddenEmail] = useState('');
  const [otp, setOtp] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [showPass, setShowPass] = useState(false);
  const [showConfirm, setShowConfirm] = useState(false);
  const [error, setError] = useState('');

  const inputStyle = {width:'100%',padding:'10px',border:'1px solid #ddd',borderRadius:'8px',fontSize:'14px',boxSizing:'border-box',direction:'rtl'};
  const btnStyle = {width:'100%',padding:'12px',background:'#1e3a5f',color:'white',border:'none',borderRadius:'8px',cursor:'pointer',fontSize:'15px',fontWeight:'bold',marginTop:'8px'};

  const handleCheckUsername = async () => {
    if (!username) { setError('يرجى إدخال رقم الهوية'); return; }
    setLoading(true); setError('');
    try {
      const res = await API.post('/check-username/', { username });
      setHiddenEmail(res.data.hidden_email);
      setStep(2);
    } catch(e) {
      setError(e.response?.data?.error || 'رقم الهوية غير موجود');
    }
    setLoading(false);
  };

  const handleSendOTP = async () => {
    setLoading(true); setError('');
    try {
      await API.post('/forgot-password/', { username });
      setOtp('');
      setNewPassword('');
      setConfirmPassword('');
      setStep(3);
    } catch(e) {
      setError(e.response?.data?.error || 'حدث خطأ');
    }
    setLoading(false);
  };

  const handleResetPassword = async () => {
    if (!otp || !newPassword || !confirmPassword) { setError('يرجى إدخال جميع البيانات'); return; }
    if (newPassword !== confirmPassword) { setError('كلمتا المرور غير متطابقتين'); return; }
    if (newPassword.length < 6) { setError('كلمة المرور يجب أن تكون 6 أحرف على الأقل'); return; }
    setLoading(true); setError('');
    try {
      await API.post('/reset-password/', { username, otp, new_password: newPassword });
      setStep(4);
    } catch(e) {
      setError(e.response?.data?.error || 'حدث خطأ');
    }
    setLoading(false);
  };

  return (
    <div style={{minHeight:'100vh',background:'linear-gradient(135deg,#1e3a5f,#2980b9)',display:'flex',alignItems:'center',justifyContent:'center',direction:'rtl'}}>
      <div style={{background:'white',borderRadius:'16px',padding:'40px',width:'100%',maxWidth:'400px',boxShadow:'0 10px 40px rgba(0,0,0,0.2)'}}>
        <div style={{textAlign:'center',marginBottom:'24px'}}>
          <div style={{fontSize:'40px'}}>💧</div>
          <h2 style={{color:'#1e3a5f',margin:'8px 0 4px'}}>استرجاع كلمة المرور</h2>
          <p style={{color:'#666',fontSize:'13px',margin:0}}>نظام إدارة شراكات الآبار</p>
        </div>

        {step === 1 && (
          <div>
            <p style={{color:'#555',fontSize:'13px',marginBottom:'16px',textAlign:'center'}}>أدخل رقم الهوية للبحث عن حسابك</p>
            <div style={{marginBottom:'16px'}}>
              <label style={{fontSize:'12px',fontWeight:'bold',color:'#444',display:'block',marginBottom:'4px'}}>رقم الهوية / الإقامة</label>
              <input value={username} onChange={e=>setUsername(e.target.value)} placeholder="أدخل رقم الهوية"
                style={inputStyle} onKeyDown={e=>e.key==='Enter'&&handleCheckUsername()}/>
            </div>
            {error && <p style={{color:'#e74c3c',fontSize:'13px',textAlign:'center',background:'#ffeaea',padding:'8px',borderRadius:'6px'}}>{error}</p>}
            <button onClick={handleCheckUsername} disabled={loading} style={btnStyle}>{loading ? 'جاري البحث...' : '🔍 بحث'}</button>
          </div>
        )}

        {step === 2 && (
          <div>
            <div style={{background:'#eaf4fb',borderRadius:'10px',padding:'16px',marginBottom:'16px',textAlign:'center'}}>
              <p style={{color:'#555',fontSize:'13px',margin:'0 0 8px'}}>سيتم إرسال رمز التحقق على بريدك الإلكتروني:</p>
              <p style={{color:'#1e3a5f',fontWeight:'bold',fontSize:'16px',margin:0}}>📧 {hiddenEmail}</p>
            </div>
            {error && <p style={{color:'#e74c3c',fontSize:'13px',textAlign:'center',background:'#ffeaea',padding:'8px',borderRadius:'6px'}}>{error}</p>}
            <button onClick={handleSendOTP} disabled={loading} style={btnStyle}>{loading ? 'جاري الإرسال...' : '📧 إرسال رمز التحقق'}</button>
            <button onClick={()=>{setStep(1);setError('');}} style={{...btnStyle,background:'#95a5a6',marginTop:'8px'}}>رجوع</button>
          </div>
        )}

        {step === 3 && (
          <div>
            <p style={{color:'#27ae60',fontSize:'13px',marginBottom:'16px',textAlign:'center',background:'#eafaf1',padding:'8px',borderRadius:'6px'}}>✅ تم إرسال رمز التحقق على {hiddenEmail}</p>
            <div style={{marginBottom:'12px'}}>
              <label style={{fontSize:'12px',fontWeight:'bold',color:'#444',display:'block',marginBottom:'4px'}}>رمز التحقق (6 أرقام)</label>
              <input value={otp} onChange={e=>setOtp(e.target.value)} placeholder="أدخل الرمز"
                autoComplete="one-time-code" name="otp-code"
                style={{...inputStyle,textAlign:'center',fontSize:'20px',letterSpacing:'8px'}}/>
            </div>
            <div style={{marginBottom:'12px'}}>
              <label style={{fontSize:'12px',fontWeight:'bold',color:'#444',display:'block',marginBottom:'4px'}}>كلمة المرور الجديدة</label>
              <div style={{position:'relative'}}>
                <input type={showPass?'text':'password'} value={newPassword} onChange={e=>setNewPassword(e.target.value)}
                  placeholder="6 أحرف على الأقل (حروف وأرقام)" autoComplete="new-password"
                  style={{...inputStyle,paddingLeft:'40px'}}/>
                <button type="button" onClick={()=>setShowPass(!showPass)}
                  style={{position:'absolute',left:'10px',top:'50%',transform:'translateY(-50%)',background:'none',border:'none',cursor:'pointer',fontSize:'16px'}}>
                  {showPass?'🙈':'👁️'}
                </button>
              </div>
            </div>
            <div style={{marginBottom:'16px'}}>
              <label style={{fontSize:'12px',fontWeight:'bold',color:'#444',display:'block',marginBottom:'4px'}}>تأكيد كلمة المرور</label>
              <div style={{position:'relative'}}>
                <input type={showConfirm?'text':'password'} value={confirmPassword} onChange={e=>setConfirmPassword(e.target.value)}
                  placeholder="أعد إدخال كلمة المرور" autoComplete="new-password"
                  style={{...inputStyle,paddingLeft:'40px'}}/>
                <button type="button" onClick={()=>setShowConfirm(!showConfirm)}
                  style={{position:'absolute',left:'10px',top:'50%',transform:'translateY(-50%)',background:'none',border:'none',cursor:'pointer',fontSize:'16px'}}>
                  {showConfirm?'🙈':'👁️'}
                </button>
              </div>
            </div>
            {error && <p style={{color:'#e74c3c',fontSize:'13px',textAlign:'center',background:'#ffeaea',padding:'8px',borderRadius:'6px'}}>{error}</p>}
            <button onClick={handleResetPassword} disabled={loading} style={btnStyle}>{loading ? 'جاري التغيير...' : 'تغيير كلمة المرور'}</button>
          </div>
        )}

        {step === 4 && (
          <div style={{textAlign:'center'}}>
            <div style={{fontSize:'50px',marginBottom:'16px'}}>✅</div>
            <h3 style={{color:'#27ae60'}}>تم بنجاح!</h3>
            <p style={{color:'#555'}}>تم تغيير كلمة المرور بنجاح</p>
            <button onClick={onBack} style={btnStyle}>تسجيل الدخول الآن</button>
          </div>
        )}

        {step !== 4 && (
          <button onClick={onBack} style={{...btnStyle,background:'transparent',color:'#888',border:'1px solid #ddd',marginTop:'8px'}}>
            ← العودة لتسجيل الدخول
          </button>
        )}
      </div>
    </div>
  );
}

export default ForgotPassword;
